import { render, staticRenderFns } from "./public-dashboard.vue?vue&type=template&id=4c267648"
import script from "./public-dashboard.vue?vue&type=script&lang=js"
export * from "./public-dashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports